import script from "./QuestionSection.vue?vue&type=script&setup=true&lang=js"
export * from "./QuestionSection.vue?vue&type=script&setup=true&lang=js"

import "./QuestionSection.vue?vue&type=style&index=0&id=67688b7c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67688b7c"]])

export default __exports__